// The data sources that are used to load the dashboard. This must match the backend data source
export const DATA_SOURCES = {
  fundraising: {
    id: "fundraising-data-source",
    title: "Fundraising Data Source",
    subtitle: "Explore Offerings, Prospects, and more",
  },
};

export const NEW_DASHBOARD_IMAGE = {
  src: "https://app.junipersquare.com/static/reporting/new-dashboard.png",
  alt: "New Dashboard Image",
  title: "This dashboard is empty",
  subtitle: "Get started by adding your first visualization",
};

export const REDSHIFT_DATA_SOURCES = {
  fundraising: [
    {
      id: "df.redshift.contact",
      title: "Contacts Data Source",
      subtitle: "Explore Contacts",
    },
    {
      id: "df.redshift.offering",
      title: "Offerings Data Source",
      subtitle: "Explore Offerings",
    },
    {
      id: "df.redshift.prospect",
      title: "Prospects Data Source",
      subtitle: "Explore Prospects",
    },
  ],
};
